module.exports = __webpack_public_path__ + "img/politics-campaign.73ef5315.jpg";